<template>
    <section  :class="shit$(`mxh:calc(100% - 90px - 46px); fixed; overflow:a; right:30px; bottom:30px; z:999; dis:f; flex-d:c-r;`)">
        <T-notify  v-for="(o) in notifyInstance" :key="o.id" :data="o" />
    </section>
</template>

<script>
import TNotify from '@/code-lab/view/organization/notify.vue'
import { mapState } from 'vuex'
export default {
    components: { "T-notify": TNotify, },
    computed: {
        ...mapState('notifySystem', { notifyInstance: 'notifyInstance' }),
        ...mapState(['add'])
    },
    watch: {
        
        
        
    },
}
</script>

